import { QueryClient } from "react-query";
import { minutesToMilliseconds } from "lib/date-time-utils";

const handleError = (error) => {
  console.log('An error is happening');
};

export const createQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        cacheTime: minutesToMilliseconds(10),
        staleTime: Infinity,
        refetchOnWindowFocus: false,
        retry: 0,
        onError: handleError,
      },
      mutations: {
        onError: handleError,
      },
    },
  });
